// extracted by mini-css-extract-plugin
export default {"main":"ModalDetalleAsistencias_main__FNbV7","header":"ModalDetalleAsistencias_header__89j36"};